import type { ComponentPropsWithoutRef } from "react";
import { t } from "ttag";

import { AvailableDaysCalendar } from "@/app/components/legacy-components";
import { useScheduleContext } from "@/features/consultations/contexts";
import { PROVIDER_PREFERENCE } from "@/shared/models/legacy-constants";
import { Card } from "@/shared/ui";
import { tw } from "@/shared/utils";

interface ScheduleAvailableDaysCardProps
  extends ComponentPropsWithoutRef<typeof Card.Root> {
  title: string;
}

export const ScheduleAvailableDaysCard = ({
  title,
  className,
  ...props
}: ScheduleAvailableDaysCardProps) => {
  const { providerPreference, provider } = useScheduleContext();

  const availability = provider ? t`on ${provider.fullName} calendar` : t`ones`;

  const disabled =
    providerPreference === PROVIDER_PREFERENCE.CUSTOM && !provider;

  return (
    <Card.Root
      className={tw(className, disabled && "cursor-not-allowed opacity-50")}
      {...props}
    >
      <Card.Title>{title}</Card.Title>

      <Card.Description>{t`The highlighted dates are the available ${availability}`}</Card.Description>

      <div className={tw(disabled && "pointer-events-none")}>
        <AvailableDaysCalendar />
      </div>
    </Card.Root>
  );
};
